import { forwardRef } from 'react';
import { cn } from '@bridebook/aura';
import { Search } from '../../icons';
import { Input, type InputProps } from './input';

export interface SearchInputProps extends Omit<InputProps, 'icon'> {}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, showClearBtn = true, ...props }, ref) => (
    <Input
      ref={ref}
      icon={Search}
      showClearBtn={showClearBtn}
      className={cn('rounded-full', className)}
      {...props}
    />
  ),
);

SearchInput.displayName = 'SearchInput';
